import { mergeStyles } from '@fluentui/react';

// Styles for selected items
export const selectedItemListStyles = mergeStyles({
    marginTop: '8px',
    border: '1px solid #edebe9',
    borderRadius: '2px',
    padding: '8px',
    maxHeight: '200px',
    overflowY: 'auto',
    width: '100%',
});

export const selectedItemStyles = mergeStyles({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px',
    margin: '4px 0',
    borderRadius: '2px',
});
